// extracted by mini-css-extract-plugin
module.exports = {"page-container":"LayoutWithHeader_page-container__1Kmw8"};